export default __webpack_public_path__ + "static/media/chevron-down.0120b565.svg";